import { render, staticRenderFns } from "./OxygenCopyPastContextMenu.vue?vue&type=template&id=9db78f10&"
import script from "./OxygenCopyPastContextMenu.vue?vue&type=script&lang=ts&"
export * from "./OxygenCopyPastContextMenu.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenCopyPastContextMenu.vue?vue&type=style&index=0&id=9db78f10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports